import { createContext } from "react";

import { ModuleContextValue } from "./types";

export const ModuleContext = createContext<ModuleContextValue | undefined>(undefined);
ModuleContext.displayName = "ModuleContext";
